import { useGame } from "../store.js";
import { CashoutButton } from "./CashoutButton.js";

interface Props {
  onClick: () => void;
}

/**
 * Connected wrapper — subscribes to tick-updated multiplier + betAmount so the
 * cashout payout updates in real time without re-rendering GameView.
 */
export function LiveCashoutButton({ onClick }: Props) {
  const multiplier = useGame((s) => s.multiplier);
  const betAmount = useGame((s) => s.betAmount);
  const currency = useGame((s) => s.currency);
  return (
    <CashoutButton
      amount={betAmount}
      multiplier={multiplier}
      currency={currency}
      onClick={onClick}
    />
  );
}
